import axios from 'axios'

import { DepartmentResource, DepartmentViewModel } from './Departments'
import { transformDepartmentResource } from './DepartmentsTransformers'

export const fetchDepartmentsApiCall = async (): Promise<DepartmentViewModel[]> => {
    const includes = ['group']

    const url = new URL(`${process.env.REACT_APP_API_URL}/departments`)

    url.searchParams.append('include', includes.join(','))

    const response = await axios.get<DepartmentResource[]>(String(url))

    return response.data.map(transformDepartmentResource)
}